export const routePaths = {
    root: "/",
    profile: "/profile",
    settings: "/settings",
};